document.addEventListener("DOMContentLoaded", () => {
  // =============================================
  // 1. CONFIG
  // =============================================
  const CONFIG = {
    // Backend face cutout API
    apiUrl: "https://technological-sewing-vbulletin-marble.trycloudflare.com/api/face-cutout",

    // Apippa / Custom Price Calculator
    calculatorId: "1536db9024404",

    // IMPORTANT:
    productId: 7975126368304,

    basePrice: 14.41,
  };

  // =============================================
  // 2. STATE MANAGEMENT
  // =============================================
  const state = {
    originalImage: null,
    cutoutImage: null,
    cutoutImageUrl: "",
    size: "Small",
    quantity: 1,
    price: CONFIG.basePrice,
  };

  // =============================================
  // 3. PRICE VARIANTS
  // =============================================
  const PRICE_VARIANTS = {
    size: [
      { value: "Small", price: 14.41 },
      { value: "Medium", price: 33.69 },
    ],
  };

  const ALLOWED_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/webp",
  ];

  // =============================================
  // 4. ELEMENTS
  // =============================================
  const uploadBtn = document.getElementById("upload-face-photo-btn");
  const uploadInput = document.getElementById("upload-face-photo");

  const cutoutPreview = document.getElementById("face-cutout-preview-wrapper");

  const uploadArtbox = document.getElementById("upload-artbox");
  const previewBox = document.getElementById("preview-box");
  const previewImage = document.getElementById("preview-image");

  const deleteBtn = document.getElementById("delete-face-image");
  const changeBtn = document.getElementById("change-face-image");

  const processingEl = document.getElementById("face-cutout-processing");
  const statusEl = document.getElementById("face-cutout-status");

  const quantityInput = document.getElementById("face-cutout-quantity");
  const addToCartBtn = document.getElementById("pcs-add-to-cart");

  // =============================================
  // 5. HELPERS
  // =============================================
  function show(el) {
    if (el) el.style.display = "";
  }

  function hide(el) {
    if (el) el.style.display = "none";
  }

  function setStatus(message, type = "") {
    if (!statusEl) return;

    statusEl.textContent = message || "";
    statusEl.className = "status-message";

    if (cutoutPreview) {
      cutoutPreview.classList.remove("ok", "err");
    }

    if (type) {
      statusEl.classList.add(type);

      if (cutoutPreview) {
        cutoutPreview.classList.add(type);
      }
    }
  }

  function priceOf(groupKey, chosenValue) {
    const list = PRICE_VARIANTS[groupKey] || [];
    const found = list.find((item) => item.value === chosenValue);
    return found ? Number(found.price) || 0 : 0;
  }

  function animatePriceChange(targetElement, start, end, duration = 500) {
    if (!targetElement) return;

    let startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;

      const progress = Math.min((timestamp - startTime) / duration, 1);
      const currentValue = start + (end - start) * progress;

      targetElement.textContent = currentValue.toFixed(2);

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  function recalcPrice() {
    const sizePrice = priceOf("size", state.size);
    const quantity = Number(state.quantity) || 1;

    // Formula: selected size price × quantity
    const total = Math.round(sizePrice * quantity * 100) / 100;

    const priceEl = document.getElementById("pcs-final-price");

    if (priceEl) {
      const prevValue = parseFloat(priceEl.textContent) || 0;

      if (prevValue !== total) {
        animatePriceChange(priceEl, prevValue, total);
      }
    }

    state.price = total;
  }

  function validateFile(file) {
    if (!file) {
      return "Please upload a photo.";
    }

    if (!ALLOWED_TYPES.includes(file.type)) {
      return "Unsupported file type. Please upload jpg, jpeg, png, or webp.";
    }

    return "";
  }

  function validateForm() {
    let isValid = true;

    const sizeVariant = document.getElementById("size-select-variant");
    const sizeError = document.getElementById("size-error-bar");

    const quantityVariant = document.getElementById("quantity-variant");
    const quantityError = document.getElementById("quantity-error-bar");

    if (!state.cutoutImage) {
      setStatus("Please upload your photo first.", "err");
      isValid = false;
    }

    if (!state.size) {
      if (sizeVariant) sizeVariant.classList.add("has-error");
      show(sizeError);
      isValid = false;
    } else {
      if (sizeVariant) sizeVariant.classList.remove("has-error");
      hide(sizeError);
    }

    const quantity = Number(state.quantity);

    if (!quantity || quantity < 1) {
      if (quantityVariant) quantityVariant.classList.add("has-error");
      show(quantityError);
      isValid = false;
    } else {
      if (quantityVariant) quantityVariant.classList.remove("has-error");
      hide(quantityError);
    }

    return isValid;
  }

  function showPreviewImage(src) {
    if (!previewImage) return;

    previewImage.src = src;
    previewImage.alt = "Face Cutout Preview";
  }

  function showProcessing() {
    show(processingEl);
    setStatus("Processing image...", "");
  }

  function hideProcessing() {
    hide(processingEl);
  }

  function resetUploader() {
    state.originalImage = null;
    state.cutoutImage = null;
    state.cutoutImageUrl = "";

    if (uploadInput) uploadInput.value = "";

    if (previewImage) previewImage.src = "";

    hide(previewBox);
    show(uploadArtbox);
    hideProcessing();

    setStatus("", "");
  }

  function blobToFile(blob, filename) {
    return new File([blob], filename, {
      type: blob.type || "image/png",
      lastModified: Date.now(),
    });
  }

  // =============================================
  // 6. FACE CUTOUT UPLOAD HANDLING
  // =============================================
  async function handleFacePhotoUpload(file) {
    const fileError = validateFile(file);

    if (fileError) {
      setStatus(fileError, "err");
      return;
    }

    state.originalImage = file;
    state.cutoutImage = null;

    const localPreviewUrl = URL.createObjectURL(file);

    hide(uploadArtbox);
    show(previewBox);
    showPreviewImage(localPreviewUrl);
    showProcessing();

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await fetch(CONFIG.apiUrl, {
        method: "POST",
        body: formData,
      });

      if (!res.ok) {
        let msg = "Could not process this image. Please upload a clear front-facing photo.";

        try {
          const data = await res.json();

          if (data && data.detail) {
            msg = data.detail;
          }
        } catch (_) {}

        throw new Error(msg);
      }

      const blob = await res.blob();
      const cutoutUrl = URL.createObjectURL(blob);

      const safeName = file.name.replace(/\.[^/.]+$/, "");
      const cutoutFile = blobToFile(blob, `${safeName}-face-cutout.png`);

      state.cutoutImage = cutoutFile;
      state.cutoutImageUrl = cutoutUrl;

      showPreviewImage(cutoutUrl);
      hideProcessing();
      setStatus("Cutout ready", "ok");
    } catch (err) {
      console.error("Face Cutout Upload Error:", err);

      state.cutoutImage = null;
      hideProcessing();

      setStatus(
        err.message || "Could not process this image. Please upload a clear front-facing photo.",
        "err"
      );
    }
  }

  function setupFacePhotoUpload() {
    if (uploadBtn && uploadInput) {
      uploadBtn.addEventListener("click", (e) => {
        e.preventDefault();
        uploadInput.click();
      });
    }

    if (changeBtn && uploadInput) {
      changeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        uploadInput.click();
      });
    }

    if (uploadInput) {
      uploadInput.addEventListener("change", (e) => {
        const file = e.target.files[0];

        if (!file) return;

        handleFacePhotoUpload(file);
      });
    }

    if (deleteBtn) {
      deleteBtn.addEventListener("click", (e) => {
        e.preventDefault();
        resetUploader();
      });
    }
  }

  // =============================================
  // 7. DROPDOWN HANDLING
  // =============================================
  function initDropdownDefaults() {
    document.querySelectorAll(".select-dropdown").forEach((dd) => {
      const preSel = dd.querySelector("li.selected");
      const header = dd.querySelector(".selected-text");
      const stateKey = dd.dataset.stateKey;

      if (preSel && header) {
        header.textContent = preSel.textContent.trim();

        if (stateKey && preSel.dataset.value) {
          state[stateKey] = preSel.dataset.value;
        }
      }
    });
  }

  function dropdownClickHandler(evt) {
    const dropdown = evt.target.closest(".select-dropdown");

    if (!dropdown) {
      document.querySelectorAll(".dropdown-options").forEach((list) => {
        hide(list);
      });

      return;
    }

    const list = dropdown.querySelector(".dropdown-options");
    const header = dropdown.querySelector(".selected-text");
    const stateKey = dropdown.dataset.stateKey;
    const optionEl = evt.target.closest("li[data-value]");

    document.querySelectorAll(".dropdown-options").forEach((other) => {
      if (other !== list) hide(other);
    });

    if (optionEl) {
      const value = optionEl.dataset.value;

      if (!value) return;

      list.querySelectorAll("li").forEach((li) => {
        li.classList.remove("selected");
      });

      optionEl.classList.add("selected");

      if (header) {
        header.textContent = optionEl.textContent.trim();
      }

      dropdown.classList.add("variant-picked");

      if (stateKey) {
        state[stateKey] = value;
      }

      recalcPrice();
      hide(list);

      return;
    }

    if (list) {
      list.style.display = list.style.display === "block" ? "none" : "block";
    }
  }

  // =============================================
  // 8. QUANTITY HANDLING
  // =============================================
  function setupQuantity() {
    if (!quantityInput) return;

    quantityInput.addEventListener("input", () => {
      let value = parseInt(quantityInput.value, 10);

      if (!value || value < 1) {
        value = 1;
      }

      state.quantity = value;
      recalcPrice();
    });

    quantityInput.addEventListener("blur", () => {
      let value = parseInt(quantityInput.value, 10);

      if (!value || value < 1) {
        value = 1;
      }

      quantityInput.value = value;
      state.quantity = value;

      recalcPrice();
    });
  }

  // =============================================
  // 9. ADD TO CART / APIPPA FUNCTIONALITY
  // =============================================
  function setupApippaAddToCart() {
    if (!addToCartBtn) return;

    addToCartBtn.addEventListener("click", async (e) => {
      e.preventDefault();

      if (!validateForm()) {
        console.log("Form invalid – fix the highlighted fields.");
        return;
      }

      console.log("Form valid – adding to cart:", state);

      addToCartBtn.disabled = true;
      addToCartBtn.classList.add("loading");

      addToCartBtn.innerHTML = `
        <div class="pcs-loader"></div>
        <p class="pcs-message"></p>
        <div class="dot-falling"></div>
      `;

      const messageEl = addToCartBtn.querySelector(".pcs-message");
      const messages = ["Adding to cart", "GETTING THINGS READY"];
      let messageIndex = 0;
      let stopTypingLoop = false;

      const startTypingLoop = async () => {
        while (!stopTypingLoop) {
          const message = messages[messageIndex % messages.length];

          await typeText(messageEl, message);
          await new Promise((resolve) => setTimeout(resolve, 2000));
          await deleteText(messageEl);

          messageIndex++;
        }
      };

      startTypingLoop();

      const loadingBar = addToCartBtn.querySelector(".pcs-loader");
      let progress = 0;
      const target = 99;

      const interval = setInterval(() => {
        if (!loadingBar) return;

        if (progress < 50) {
          progress += 2;
        } else if (progress < 80) {
          progress += (80 - progress) * 0.05;
        } else if (progress < target - 0.2) {
          progress += (target - progress) * 0.05;
        } else {
          progress = target - 0.01;
          clearInterval(interval);
        }

        loadingBar.style.transform = `scaleX(${Math.floor(progress)}%)`;
      }, 80);

      try {
        const requestData = {
          calculatorId: CONFIG.calculatorId,
          productId: CONFIG.productId,
          properties: {
            Size: state.size,
            Quantity: String(state.quantity),
            "Face Cutout Image": state.cutoutImage?.name || "",
          },
        };

        console.log("Apippa Request Data:", requestData);

        const variantRes = await fetch(
          "https://api.custompricecalculator.com/api/v1/variant",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
          }
        );

        const variantId = await variantRes.json();

        const shopifyVariantId =
          typeof variantId === "string"
            ? variantId
            : variantId?.variantId || variantId?.id;

        if (!shopifyVariantId) {
          throw new Error("Invalid variant ID");
        }

        const formData = new FormData();

        formData.append("id", shopifyVariantId);
        formData.append("quantity", state.quantity);

        Object.entries(requestData.properties).forEach(([key, value]) => {
          formData.append(`properties[${key}]`, value);
        });

        if (state.cutoutImage) {
          formData.append("properties[Face Cutout Image]", state.cutoutImage);
        }

        const cartAddRes = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        });

        const cartAddJson = await cartAddRes.json();

        console.log("Add to Cart Response:", cartAddJson);

        if (!cartAddRes.ok) {
          throw new Error("Failed to add to cart");
        }

        localStorage.setItem(
          `patched-cart-item-${cartAddJson.id}`,
          JSON.stringify({
            id: cartAddJson.id,
            title: cartAddJson.product_title,
            image: cartAddJson.image,
            price: cartAddJson.price,
          })
        );

        const cartJson = {
          items: [cartAddJson],
          item_count: Number(state.quantity) || 1,
          total_price: cartAddJson.final_price,
          original_total_price: cartAddJson.original_price,
          total_discount: 0,
        };

        await refreshMiniCart(cartJson, shopifyVariantId);
      } catch (err) {
        console.error("Apippa Add to Cart Error:", err);
        alert("There was a problem adding your item to the cart.");
      } finally {
        clearInterval(interval);

        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove("loading");
        addToCartBtn.innerHTML = "Add to Cart";

        stopTypingLoop = true;
      }
    });
  }

  async function refreshMiniCart(cartJson, shopifyVariantId) {
    const timestamp = new Date().getTime();

    await new Promise((resolve) => setTimeout(resolve, 200));

    const sectionHtml = await fetch(
      `/cart?section_id=mini-cart&t=${timestamp}`
    ).then((res) => res.text());

    const fakeDiv = document.createElement("div");
    fakeDiv.innerHTML = sectionHtml;

    const miniCartHTML = fakeDiv.querySelector("cart-drawer")?.outerHTML;
    const cartDrawer = document.querySelector("cart-drawer");

    if (cartDrawer && miniCartHTML) {
      cartDrawer.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: {
              ...cartJson,
              sections: {
                "mini-cart": miniCartHTML,
              },
            },
            openMiniCart: true,
          },
        })
      );
    }

    setTimeout(async () => {
      try {
        const latestCartJson = await fetch("/cart.js").then((res) => res.json());
        const cartCountEl = document.querySelector("cart-count");

        if (cartCountEl) {
          cartCountEl.textContent = latestCartJson.item_count;
        }
      } catch (err) {
        console.error("Cart count update error:", err);
      }
    }, 300);

    setTimeout(() => {
      const drawerContent = document.querySelector(
        "#shopify-section-mini-cart .drawer__content"
      );

      if (!drawerContent) return;

      const confetti = document.createElement("dotlottie-player");

      confetti.className = "mini-cart-lottie";
      confetti.src =
        "//cdn.shopify.com/s/files/1/0582/5400/0176/files/confetti.json?v=1748024242";
      confetti.setAttribute("background", "transparent");
      confetti.setAttribute("speed", "1");
      confetti.setAttribute("style", "width: 300px; height: 300px");
      confetti.setAttribute("direction", "1");
      confetti.setAttribute("playmode", "normal");
      confetti.setAttribute("autoplay", "");

      drawerContent.prepend(confetti);

      setTimeout(() => {
        confetti.remove();
      }, 3000);
    }, 1000);

    console.log("Mini cart refreshed for variant:", shopifyVariantId);
  }

  // =============================================
  // 10. TEXT ANIMATION HELPERS
  // =============================================
  function typeText(el, text, speed = 60) {
    return new Promise((resolve) => {
      if (!el) {
        resolve();
        return;
      }

      let i = 0;

      const typeInterval = setInterval(() => {
        el.textContent += text[i];
        i++;

        if (i >= text.length) {
          clearInterval(typeInterval);
          resolve();
        }
      }, speed);
    });
  }

  function deleteText(el, speed = 40) {
    return new Promise((resolve) => {
      if (!el) {
        resolve();
        return;
      }

      const delInterval = setInterval(() => {
        el.textContent = el.textContent.slice(0, -1);

        if (el.textContent.length === 0) {
          clearInterval(delInterval);
          resolve();
        }
      }, speed);
    });
  }

  // =============================================
  // 11. INITIALIZE
  // =============================================
  function initialize() {
    setupFacePhotoUpload();
    initDropdownDefaults();
    setupQuantity();
    setupApippaAddToCart();

    document.addEventListener("click", dropdownClickHandler);

    recalcPrice();
  }

  initialize();
});